import {
  Button,
  createStyles,
  Fab,
  Grid,
  Hidden,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Tabs,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import DeleteIcon from "@material-ui/icons/Delete";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment-timezone";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import {
  StyledPaperTabs,
  StyledTab,
} from "../../components/CustomStyles/CustomTabs";
import InputSearch from "../../components/InputSearch/InputSearch";
import { formatCurrency } from "../../components/Utils/Currency";
import voucherStore from "../../Store/VoucherStore";
import { showDetail } from "./parts/detail";
import { showForm } from "./parts/form";
import Img from "../../components/Img";
import FormatNumber from "../../components/Utils/formatcuRupiah";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
    cardTitle: {
      color: theme.palette.primary.dark,
      fontWeight: "bolder",
    },
    cardSubHeader: {
      fontSize: "smaller",
    },
  })
);

const LoadingListVoucher = () => {
  return (
    <StyledTableRow>
      <StyledTableCell>
        <Skeleton width={16} height={16} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton width={145} height={19} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton width={74} height={15} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton width={74} height={15} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton width={21} height={15} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton width={18} height={15} />
      </StyledTableCell>
      <StyledTableCell align="right">
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ marginRight: 25 }}>
            <Skeleton width={30} height={40} />
          </div>
          <Skeleton width={30} height={40} />
        </div>
      </StyledTableCell>
    </StyledTableRow>
  );
};

const ListVoucher = (props) => {
  const classes = useStyles();
  const { value, no, showDetail, onDelete, deleted, access } = props;
  // console.log(value);
  return (
    <StyledTableRow>
      <StyledTableCell>{no}</StyledTableCell>
      <StyledTableCell>
        {/* {value.image_voucher === "" ? (
          <strong>No Image</strong>
        ) : (
          <Img src={value.image_voucher} width={60} height={60} />
        )} */}
        <strong>{value.code}</strong>
      </StyledTableCell>
      <StyledTableCell>
        <Typography style={{ color: "#2196F3", fontSize: 13 }}>
          {value.name}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        {moment(value.start_date)
          .tz(value.property?.timezone || "Asia/Jakarta")
          .format("DD - MM - YYYY HH:mm")}
      </StyledTableCell>
      <StyledTableCell>
        {/* {moment(value.end_date)
          .tz(value.property?.timezone || "Asia/Jakarta")
          .format("DD - MM - YYYY HH:mm")} */}
        {FormatNumber(`${value.minimum_transaction}`)}
      </StyledTableCell>
      <StyledTableCell>
        {FormatNumber(`${value.quota}`)}

        {/* {formatCurrency(value.property?.currency, value.stock.toString(), true)} */}
      </StyledTableCell>
      <StyledTableCell>
        {/* {formatCurrency(value.property?.currency, value.stock.toString(), true)} */}
        {/* {value.used} */}
        {FormatNumber(`${value.used}`)}
      </StyledTableCell>
      <StyledTableCell>
        {/* {value.stock} */}
        {FormatNumber(`${value.stock}`)}

        {/* {formatCurrency(value.proper  ty?.currency, value.stock.toString(), true)} */}
      </StyledTableCell>
      <StyledTableCell>
        {value.type.name}
        {/* {formatCurrency(value.property?.currency, value.sold.toString(), true)} */}
      </StyledTableCell>
      <StyledTableCell align="right">
        {access?.delete && !deleted && (
          <IconButton aria-label="delete voucher" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        )}
        <IconButton
          color="secondary"
          aria-label="detail voucher"
          onClick={showDetail}
        >
          <ArrowForwardIcon />
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  );
};

const VoucherList = (props) => {
  const classes = useStyles();
  const user = JSON.parse(localStorage.getItem("user"));
  const [search, setSearch] = React.useState("");
  const [voucherState, voucherActions] = voucherStore();
  const [tabActive, setTabActive] = React.useState(0);
  const arrTabs = [
    { label: "Voucher List", deleted: false },
    { label: "Removed", deleted: true },
  ];
  let perPage = 10;

  const usePreviousTab = (value) => {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  };

  const prevTabActive = usePreviousTab(tabActive);

  const handleChangeTab = (event, newTab) => {
    setTabActive(newTab);
  };

  const handleGetVoucherList = (refresh) => {
    var query = {
      num: perPage.toString(),
      type: "",
      // tenant_id: user?.type === "tenant" ? user?.tenant?.id : "",
      property_id: user.operational.id,
      cursor: refresh ? "" : voucherState.header["x-cursor"] || "",
      deleted: arrTabs[tabActive].deleted === true ? "true" : "false",
      keyword: search,
    };
    voucherActions.getList(query, refresh);
  };

  const handleSearch = async (e) => {
    setSearch(e.target.value);
  };

  const handleShowForm = (value) => {
    if (value === null) {
      showForm(value, handleGetVoucherList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    } else {
      showForm(value, handleGetVoucherList).then(
        (process) => {
          // handleActions(value);
        },
        (cancel) => {
          // setUpdate(!update);
        }
      );
    }
  };

  const handleDelete = (id) => {
    confirm(`Delete Voucher`, `Are you sure to delete this voucher ?`).then(
      async (onProcess) => {
        await voucherActions.deleted(id);
        handleGetVoucherList(true);
      }
    );
  };

  const handleShowDetail = (value) => {
    showDetail(
      value,
      props.params,
      arrTabs[tabActive].deleted,
      handleShowForm,
      handleDelete,
      handleGetVoucherList
    ).then(
      (process) => {
        handleShowForm(value);
      },
      (cancel) => {
        // setUpdate(!update);
      }
    );
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const refresh = true;
      handleGetVoucherList(refresh);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, tabActive]);

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h3>Voucher / Voucher List</h3>
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <Grid
          item
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between"
          xs={12}
        >
          <InputSearch
            value={search}
            onChange={(e) => {
              handleSearch(e);
            }}
            placeholder="Search"
          />
          <Hidden xsDown implementation="css">
            {props.params.create && (
              <Tooltip
                title="add voucher"
                aria-label="add"
                arrow
                placement="bottom"
              >
                <Button
                  onClick={() => handleShowForm(null)}
                  color="secondary"
                  variant="contained"
                >
                  <Add style={{ marginRight: "0.5rem" }} /> Add
                </Button>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
        <Grid item xs={12}>
          <StyledPaperTabs square>
            <Tabs
              value={tabActive}
              onChange={handleChangeTab}
              scrollButtons="auto"
              aria-label="Voucher tab"
            >
              {arrTabs.map((row, key) => {
                return <StyledTab key={key} label={row.label} />;
              })}
            </Tabs>
          </StyledPaperTabs>
          <TableContainer>
            <Table style={{ minWidth: 690 }}>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" width="5%">
                    #
                  </StyledTableCell>
                  <StyledTableCell align="left" width="10%">
                    Voucher Code
                  </StyledTableCell>
                  <StyledTableCell align="left" width="20%">
                    Name
                  </StyledTableCell>
                  <StyledTableCell align="left" width="17%">
                    Start Time
                  </StyledTableCell>
                  <StyledTableCell align="left" width="17%">
                    Minimum Transaction
                  </StyledTableCell>
                  <StyledTableCell align="left" width="6%">
                    Voucher Quota
                  </StyledTableCell>
                  <StyledTableCell align="left" width="6%">
                    Voucher Used
                  </StyledTableCell>
                  <StyledTableCell align="left" width="6%">
                    Voucher Remain
                  </StyledTableCell>
                  <StyledTableCell align="left" width="12%">
                    Voucher Type
                  </StyledTableCell>
                  <StyledTableCell></StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {voucherState.data.length > 0 &&
                  voucherState.data.map((row, key) => {
                    return (
                      <ListVoucher
                        key={row.id}
                        value={row}
                        no={key + 1}
                        showDetail={() => handleShowDetail(row)}
                        onDelete={() => handleDelete(row.id)}
                        deleted={arrTabs[tabActive].deleted}
                        access={props.params}
                      />
                    );
                  })}
                {voucherState.isLoading &&
                  Array.from(new Array(perPage)).map((row, key) => {
                    return <LoadingListVoucher key={key} />;
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {!voucherState.isLoading && voucherState.data.length === 0 && (
          <Grid item xs={12}>
            <div className={classes.demo1}>
              <Grid
                item
                xs
                container
                justify="center"
                style={{ margin: 10, padding: 12 }}
              >
                <span>No Data</span>
              </Grid>
            </div>
          </Grid>
        )}
        {voucherState.data.length >= perPage && (
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ padding: "10px" }}
          >
            {voucherState.lastPage ? (
              <h2>~</h2>
            ) : (
              <Button
                onClick={() => handleGetVoucherList(false)}
                size="small"
                color="secondary"
                variant="contained"
                disabled={voucherState.isLoading}
              >
                {voucherState.isLoading ? "Please Wait" : "Load More"}
              </Button>
            )}
          </Grid>
        )}
      </Grid>
      <Hidden smUp implementation="css">
        {props.params.create && (
          <Tooltip title="add voucher" aria-label="add" arrow placement="left">
            <Fab
              aria-label="Add"
              classes={{ root: "FabMobile" }}
              className={classes.fab}
              color="primary"
              onClick={() => handleShowForm(null)}
            >
              <Add />
            </Fab>
          </Tooltip>
        )}
      </Hidden>
    </BaseLayout>
  );
};

export default VoucherList;
